/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Blocked_Line_CapInputs */



/**
* | output |
* | --- |
* | "Too many customer lines for one credit note, so this quarter needs handling by hand." |
*
* @param {Partner_Admin_Commission_Blocked_Line_CapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_blocked_line_cap = /** @type {((inputs?: Partner_Admin_Commission_Blocked_Line_CapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Blocked_Line_CapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zu viele Kundenpositionen für eine Gutschrift, daher muss dieses Quartal manuell bearbeitet werden.")
	return /** @type {LocalizedString} */ ("Too many customer lines for one credit note, so this quarter needs handling by hand.")
});